import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslocoModule } from '@ngneat/transloco';
import { MaterialModule } from '../material/material.module';
import { LayoutActionItemCardComponent } from './layout-action-item-card/layout-action-item-card.component';
import { LayoutCalculatorComponent } from './layout-calculator/layout-calculator.component';
import { LayoutDialogComponent } from './layout-dialog/layout-dialog.component';
import { LayoutExternalComponent } from './layout-external/layout-external.component';
import { LayoutResultsComponent } from './layout-results/layout-results.component';
import { LayoutSearchComponent } from './layout-search/layout-search.component';

const exported = [
  LayoutExternalComponent,
  LayoutActionItemCardComponent,
  LayoutSearchComponent,
  LayoutResultsComponent,
  LayoutCalculatorComponent,
  LayoutDialogComponent,
];

@NgModule({
  declarations: [...exported],
  imports: [CommonModule, FlexLayoutModule, MaterialModule, TranslocoModule],
  exports: exported,
})
export class LayoutsModule {}
